import React, { createRef, type SyntheticEvent, type MouseEvent, type KeyboardEvent } from 'react';
import { SkeletonItem } from '@atlaskit/side-navigation';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { matchPartialUrlPathname } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/index.tsx';
import type { RouteName } from '@atlassian/jira-route-name-types/src/RouteName.tsx';
import { SETTINGS_IDS } from '../../../constants.tsx';
import type { SettingFeatures } from '../../../types/index.tsx';
import { getSpaUrlForClassicSettings } from '../../../utils/servicedesk-spa-url-classic-settings/index.tsx';
import messages from './messages.tsx';

type NotificationsMenuProps = {
	projectKey: string;
	features: SettingFeatures | null;
	onHandleLegacySPAClick: (
		e:
			| SyntheticEvent
			| MouseEvent<HTMLAnchorElement>
			| KeyboardEvent<HTMLAnchorElement>
			| MouseEvent<EventTarget>
			| KeyboardEvent<EventTarget>,
	) => void;
};

export const NotificationsMenu = ({
	projectKey,
	features,
	onHandleLegacySPAClick,
}: NotificationsMenuProps) => {
	const { formatMessage } = useIntl();
	if (features == null || projectKey == null) return <SkeletonItem />;
	const NOTIFICATIONS_ROUTE_NAMES: RouteName[] = [
		'project-settings-servicedesk-notifications',
		'legacy-project-settings-notifications',
		'project-settings-servicedesk-notifications-notification-email',
	];

	return (
		<>
			{features.hasNotifications && (
				<MenuItem
					analytics={{
						itemId: SETTINGS_IDS.NOTIFICATIONS,
					}}
					href={`/plugins/servlet/project-config/${projectKey}/notifications`}
					selectedOn={NOTIFICATIONS_ROUTE_NAMES}
					ref={createRef()}
				>
					{formatMessage(messages.agentNotifications)}
				</MenuItem>
			)}
			{features.hasCustomerNotifications && (
				<MenuItem
					analytics={{ itemId: SETTINGS_IDS.CUSTOMER_NOTIFICATIONS }}
					href={getSpaUrlForClassicSettings('customer-notifications', projectKey)}
					onClick={__SPA__ ? undefined : onHandleLegacySPAClick}
					selectedOn={matchPartialUrlPathname()}
					ref={createRef()}
				>
					{formatMessage(messages.customerNotifications)}
				</MenuItem>
			)}
		</>
	);
};
